import { createApi, EndpointDefinition, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IRootState } from "./app/store";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const apiRTK = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  keepUnusedDataFor: 3600,
  tagTypes: [
    "SavedRooms",
    "PredictSpace",
    "TrainedStandardRooms",
    "Rooms",
    "devices",
    "similarRoomsWithDesign",
    "mcbim",
    "projects",
    "SingleRoom",
    "ReleaseNotes",
    "MediaAssets",
    "routingGraphs",
  ],
  endpoints: () => ({}),
});

export const getCacheKey = (queries: any, cacheKeyPattern: string) => {
  const matches = Object.keys(queries)
    .filter((q) => q.startsWith(cacheKeyPattern) && queries[q]?.status === "fulfilled")
    .sort((a: string, b: string) => {
      if (queries[a]?.fulfilledTimeStamp! > queries[b]?.fulfilledTimeStamp) {
        return -1;
        // eslint-disable-next-line no-dupe-else-if
      } else if (queries[a]?.fulfilledTimeStamp! < queries[b]?.fulfilledTimeStamp!) {
        return 1;
      } else {
        return 0;
      }
    });
  if (matches.length === 0) {
    return null;
  }

  return JSON.parse(removeOuterParentheses(matches[0].replace(cacheKeyPattern, "")));
};

function removeOuterParentheses(inputString: string) {
  // Check if the string starts and ends with parentheses
  if (inputString.charAt(0) === "(" && inputString.charAt(inputString.length - 1) === ")") {
    // Remove the first and last characters
    return inputString.substring(1, inputString.length - 1);
  } else {
    // If the string doesn't start and end with parentheses, return the original string
    return inputString;
  }
}
